/**
 * LoadingState: accessible busy indicator with a live region.
 */
import { useTranslation } from 'react-i18next';

export function LoadingState(props: { message?: string }): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      className="flex min-h-[40vh] flex-col items-center justify-center gap-4"
      role="status"
      aria-live="polite"
    >
      <svg
        aria-hidden="true"
        className="h-10 w-10 animate-spin text-tenant-primary"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <p className="text-sm text-stone-600">{props.message ?? t('common.loading')}</p>
    </div>
  );
}
